export default {
  
  home: {
    section: {
      duration: 2.8,
      ease: 'expo.inOut'
    } 
  }

}